import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FiWifi } from 'react-icons/fi';
import { useAuth } from '../context/AuthContext';
import './Login.css';

const Login = () => {
  // Log para debug
  console.log('Login.js: Componente carregado, rota:', window.location.pathname);
  
  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const result = await login(
      typeof email === 'string' ? email.trim().toLowerCase() : email,
      senha
    );
    
    console.log('Login.js: Resultado do login:', result);
    
    if (result.success) {
      console.log('Login.js: Login bem-sucedido, navegando para /dashboard');
      // Pequeno delay para garantir que o estado do usuário foi atualizado
      setTimeout(() => {
        navigate('/dashboard');
      }, 100);
    } else {
      console.error('Login.js: Erro no login:', result.error);
      setError(result.error);
    }
    
    setLoading(false);
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <div className="login-icon" aria-hidden="true">
          <FiWifi />
        </div>
        <h1>Sys Conect</h1>
        {error && <div className="error-message">{error}</div>}
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div className="form-group">
            <label>Senha</label>
            <input
              type="password"
              value={senha}
              onChange={(e) => setSenha(e.target.value)}
              required
            />
          </div>
          <button type="submit" disabled={loading}>
            {loading ? 'Entrando...' : 'Entrar'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;

